// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';


import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

// loads the Icon plugin
UIkit.use(Icons);

/** Populate Router instance with DOM routes */
const routes = new Router({common,home});

jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// inc/assets/scripts/main.js